import { FunctionComponent } from 'preact';
import { LineItem } from '@pperform/pp-data-mappers';
import { lineItemTestID } from 'components/MerchantTrackingWidget/constants';
import {
  DetailedWrapper,
  QuantityPriceWrapper,
  Thumbnail,
  TruncatedDetailTitle,
} from './CardFront.styles';
import {
  DescriptionRow,
  DescriptionTitle,
  DescriptionValue,
  DetailsWrapper,
} from '../../ItemCommons/CommonItem.styles';
import { useFormatItemsCard } from '../../ItemCommons';

export interface CardFrontProps {
  card: LineItem;
  ariaHidden?: boolean;
}

const CardFront: FunctionComponent<CardFrontProps> = ({ card, ariaHidden }) => {
  const {
    productName,
    productImageUrl,
    productPrice,
    productQuantity,
    additionalInformation,
    productID,
  } = useFormatItemsCard(card);

  return (
    <DetailsWrapper isTwoColumns={false} aria-hidden={ariaHidden}>
      <Thumbnail
        alt={`Image of ${productName}`}
        isRounded={false}
        width="inherit"
        height={202}
        src={productImageUrl}
      />

      <DetailedWrapper>
        <DescriptionRow gap={4} data-testid={`${lineItemTestID}-name`}>
          <TruncatedDetailTitle isShowFull={false}>
            {productName}
          </TruncatedDetailTitle>
        </DescriptionRow>
        <QuantityPriceWrapper>
          {productPrice && (
            <DescriptionRow gap={4} data-testid={`${lineItemTestID}-price`}>
              <DescriptionValue>{`${productPrice.label}: ${productPrice.value}`}</DescriptionValue>
            </DescriptionRow>
          )}
          {productQuantity && (
            <DescriptionRow gap={4} data-testid={`${lineItemTestID}-quantity`}>
              <DescriptionValue>{productQuantity.value}</DescriptionValue>
            </DescriptionRow>
          )}
        </QuantityPriceWrapper>
        {productID && (
          <DescriptionRow gap={4} data-testid={`${lineItemTestID}-id`}>
            <DescriptionValue>{`${productID.label}: ${productID.value}`}</DescriptionValue>
          </DescriptionRow>
        )}
        {additionalInformation && (
          <DescriptionRow
            gap={4}
            data-testid={`${lineItemTestID}-additional-information`}
          >
            <DescriptionValue>{additionalInformation}</DescriptionValue>
          </DescriptionRow>
        )}
      </DetailedWrapper>
    </DetailsWrapper>
  );
};

export { CardFront };
